import Authentication from '@iez/features/authentication/blocking/'

export default () => {
  Authentication({
    registerMessage: `En vous inscrivant, vous acceptez nos <a href="https://yako.co/conditions-generales-utilisation/" target="_blank">conditions générales d'utilisation</a> ainsi que notre <a href="https://yako.co/politique-confidentialite/">politique de confidentialité</a>.`
  })
}
